<template>
  <div :class="languageCode">
    <h4 class="ml-2">
      <slot name="title">Missing Title</slot>
    </h4>
    <p class="p-small text-muted mx-2 mt-4 mb-4">
      <slot name="subtitle">Missing Content</slot>
    </p>
    <div class="range-container">
      <svg
        viewBox="0 0 318 148"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="low-high-range" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="xl-low-high-range" transform="translate(-407.000000, -333.000000)">
            <g id="Condition-value" transform="translate(407.000000, 333.000000)">
              <text
                id="amount-low"
                class="range-amount"
                line-spacing="30"
                fill="#007BC7"
                x="42%"
                y="20"
                text-anchor="end"
              >
                {{ $n(range.low.amount, 'currencyDollars', languageCode) }}
              </text>
              <text
                id="amount-average"
                class="range-amount range-highlight"
                line-spacing="45"
                fill="#007BC7"
                x="42%"
                y="85"
                text-anchor="end"
              >
                {{ $n(range.average.amount, 'currencyDollars', languageCode) }}
              </text>
              <text
                id="amount-high"
                class="range-amount"
                line-spacing="30"
                fill="#007BC7"
                x="42%"
                y="138"
                text-anchor="end"
              >
                {{ $n(range.high.amount, 'currencyDollars', languageCode) }}
              </text>
              <text id="text-low" class="range-text" line-spacing="20" fill="#19222B">
                <tspan x="187" y="20">{{ range.low.text }}</tspan>
              </text>
              <text id="text-average" class="range-text" line-spacing="20" fill="#19222B">
                <tspan x="187" y="80">{{ range.average.text }}</tspan>
              </text>
              <text id="text-high" class="range-text" line-spacing="20" fill="#19222B">
                <tspan x="187" y="138">{{ range.high.text }}</tspan>
              </text>
              <rect id="Rectangle" fill="#007BC7" x="159" y="21" width="2" height="46" rx="1"></rect>
              <rect id="Rectangle-Copy-2" fill="#007BC7" x="159" y="81" width="2" height="46" rx="1"></rect>
              <circle id="Oval" fill="#007BC7" cx="160" cy="15" r="2"></circle>
              <circle id="Oval-Copy" fill="#007BC7" cx="160" cy="74" r="3"></circle>
              <circle id="Oval" fill="#007BC7" cx="160" cy="133" r="2"></circle>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LowToHighRange',
  data() {
    return {};
  },
  props: {
    range: {
      type: Object,
      default() {
        return {
          low: { amount: 10000, text: 'Low' },
          average: { amount: 15000, text: 'Average' },
          high: { amount: 20000, text: 'High' },
        };
      },
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
      countryCode: 'business/getBusinessCountry',
    }),
  },
};
</script>

<style scoped lang="scss">
.range-container {
  position: relative;

  svg {
    text {
      font-family: 'Roboto';
      font-weight: normal;
    }

    .range-text {
      font-size: 16px;
      font-weight: bold;
    }

    .range-amount {
      font-size: 20px;
    }

    .range-highlight {
      font-size: 30px;
      font-weight: bold;
    }
  }
}

.fr-CA {
  .range-container svg text.range-text {
    font-size: 10px;
  }
}
</style>
